import type { BoardsPage } from '../../model/index.tsx';
import type { Response } from '../../rest/search-boards/get/index.tsx';
import { createBoardUrl } from '../common/index.tsx';

export const transformSearchResponseBoards = (response: Response): BoardsPage => {
	const { values, total } = response;
	const boards = values.map(({ id, name, location, type }) => ({
		id: String(id),
		name,
		url: createBoardUrl(
			id,
			(location && location.projectKey) || '',
			location?.userAccountId,
			type === 'simple',
		),
		...(location
			? {
					locationName: location.name,
					isLocationUser: !!location.userId,
					locationAvatarUrl: location.avatarURI,
				}
			: {}),
	}));
	return { values: boards, total };
};
